import { Label, styled } from '@ghq-abi/design-system';

export const InputLabel = styled(Label, {
  fontWeight: '$medium !important',
  fontSize: '$xs !important',
  color: '#7D8597 !important',

  variants: {
    dark: {
      true: {
        color: '#3F465A !important',
        fontWeight: '$bold !important',
      },
    },
  },
});

export const InputWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$xs',
  flex: 1,
  whiteSpace: 'nowrap',
  flexBasis: 'calc(100% - $4)',

  '@lg': {
    flexBasis: 'calc(50% - $4)',
  },

  '@xl': {
    flexBasis: 'calc(20% - $4)',
  },
});
